import axios from "axios";
import qs from "qs" ;
import authServices from "../../../services/authServices";
import dataProvider from "../../../services/dataProvider";

export function markTaskComplete(taskId) {
    var data = qs.stringify({
        taskIdList: JSON.stringify([taskId]),
    });
    var config = {
        method: "post",
        url: dataProvider.baseUrl + "tasks-markMultipleTasksComplete",
        headers: {
            token: authServices.getToken(),
            orgid: authServices.getOrgId(),
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
    };

    return axios(config);
}